import { styled } from '@mui/system';
import { Typography as MuiTypography } from '@mui/material';

export const FormLabel = styled(MuiTypography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: 12,
  lineHeight: 2,
  color: theme.palette.grey[800],
  '&::first-letter': {
    textTransform: 'uppercase',
  },
}));
